import { defineAction } from '~/prix'
import actionJson from './waterSourceDocumentDelete.action.json' with { type: 'json' }
import { z } from 'zod'

const definition = defineAction({
  ...actionJson,
  input: z.object({ id: z.string().uuid() }),
  output: z.object({}),
})

export default definition
